// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"48":"920a55ab","64":"56798cb4","80":"fd694df3","205":"4dd24a06","694":"15a73556","773":"db89bce2","850":"42a4ba8b","985":"59065c6d"}[chunkId] + ".css";
};